import { render, staticRenderFns } from "./ExamPrepQuestion.vue?vue&type=template&id=37eeb474"
import script from "./ExamPrepQuestion.vue?vue&type=script&lang=js"
export * from "./ExamPrepQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports